
























































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

declare var amp: any;

@Component({
  components: {
    apexchart: VueApexCharts,
  },
})
export default class PreModuleWork extends Vue {
  private tableItems: any = [];
  private tableItemsSorted = this.sortArray(this.tableItems);
  private selectedWorkItem: any = [];
  private selected: any = [];
  private display: any = [];
  private correct: any = [];
  private disable: any = [];
  private answerAns: any = [];
  private attempted = 0;
  private currentDay = "2020-04-13";
  private player: any;
  private errorMessage = "";
  private sourceLoaded = false;
  private view = 0;
  private currentWorkItem = 0;
  private source =
    "//elvideoservices-aase.streaming.media.azure.net/7bde64ac-5624-4b25-9c6b-97a24edb6208/chem1ch3lect1-new.ism/manifest";
  private isFirst = localStorage[config.dayModal];
  private auth = new AuthService();
  private service = new GeneralService();
  private lastTime = 0;
  private errorDisable = false;
  private startError = false;
  private discussions: any = [];
  private answers = ["A", "B", "C", "D"];
  private lectures: any = [];
  private worksheets: any = [];
  private tests: any = [];
  private testSubjectsData: any = [];
  private currentSubjectTest: any = 0;
  private disableTests: any = [];
  private totalQuestions: any = 0;
  private totalCorrect: any = 0;
  private subjectCorrect: any = [];
  private subjectIncorrect: any = [];
  private totalIncorrect: any = 0;
  private totalSubjects: any = [];
  private showResult: any = false;
  private startTime: any;
  private endTime: any;
  private timeElapsed = "";
  private testAttempted = true;
  private sheetId: any = "";
  private totalSeries = 0;
  private totalSeriesData;
  private notAttempted = 0;
  private isM = false;
  private showVocab = false;
  private level_id;
  private vocab = [
    {
      sr: 1,
      title: 'List 1',
      download: 'NMDCAT-Vocabulary-List-1.pdf'
    },
    {
      sr: 2,
      title: 'List 2',
      download: 'NMDCAT-Vocabulary-List-2.pdf'
    },
    {
      sr: 3,
      title: 'List 3',
      download: 'NMDCAT-Vocabulary-List-3.pdf'
    },
    {
      sr: 4,
      title: 'List 4',
      download: 'NMDCAT-Vocabulary-List-4.pdf'
    },
    {
      sr: 5,
      title: 'List 5',
      download: 'NMDCAT-Vocabulary-List-5.pdf'
    },
  ];

  private iframeHtml = '';


  get chartTotalOptions() {
    let series: any = [];
    series.push("Correct")
    series.push("Incorrect");
    series.push("Not Attempted");


    let options = {
      labels: series,
      colors: ["#00A589", "#e74c3c", "#979797"],
      legend: {
        show: false,
      },
    };
    return options;
  }

  get getTotalSeries() {
    let series: any = [];
    let total = 0;
    for (let i = 0; i < this.testSubjectsData.length; i++) {
      series.push(this.subjectCorrect[this.testSubjectsData[i].courseId]);
      total += this.subjectCorrect[this.testSubjectsData[i].courseId];
    }

    series.push(this.totalQuestions - total);
    return series;
  }

  private finishTest() {
    window.scrollTo(0, 0);
    this.endTime = moment();

    if (this.endTime.diff(this.startTime, "hours") !== 0) {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "hours", true).toFixed(2) + " Hours";
    } else if (this.endTime.diff(this.startTime, "minutes") !== 0) {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "minutes", true).toFixed(2) +
        " Minutes";
    } else {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "seconds") + " Seconds";
    }
    // let selectedWork =
    //   localStorage[config.selectedWork] !== "undefined"
    //     ? JSON.parse(localStorage[config.selectedWork])
    //     : null;

    let result: any = [];
    let series: any = [];
    let total = 0;

    let totalScore = 0;

    for (let i = 0; i < this.testSubjectsData.length; i++) {
      let temp = {
        Subject: this.testSubjectsData[i].courseId,
        Om: this.subjectCorrect[this.testSubjectsData[i].courseId],
        Im: this.subjectIncorrect[this.testSubjectsData[i].courseId],
        Tm: this.totalSubjects[this.testSubjectsData[i].courseId],
      };
      if (!this.isM)
        totalScore +=
          this.subjectCorrect[this.testSubjectsData[i].courseId] * 4 -
          this.subjectIncorrect[this.testSubjectsData[i].courseId];
      else totalScore += this.subjectCorrect[this.testSubjectsData[i].courseId];

      series.push(this.subjectCorrect[this.testSubjectsData[i].courseId]);
      total += this.subjectCorrect[this.testSubjectsData[i].courseId];

      result.push(temp);
    }

    series.push(this.totalIncorrect);
    series.push(this.totalQuestions - total - this.totalIncorrect);
    // this.service
    //   .setResult(
    //     this.sheetId,
    //     Math.max(totalScore, 0),
    //     this.isM ? this.totalQuestions:this.totalQuestions*4,
    //     JSON.stringify(result),
    //     selectedWork
    //   )
    //   .then(response => {

    //   });
    this.totalSeries++;
    this.totalSeriesData = series;
    this.showResult = true;
  }

  private changeSubject(index) {
    this.currentSubjectTest = index;
    this.selectedWorkItem = this.testSubjectsData[this.currentSubjectTest];
    this.setCorrect();
    this.disable = this.disableTests[this.selectedWorkItem.courseId];
    window.scrollTo(0, 0);
  }

  private retakeTest() {
    this.showResult = false;
    this.totalCorrect = 0;
    this.totalIncorrect = 0;
    this.notAttempted = 0;
    for (let i = 0; i < this.testSubjectsData.length; i++) {
      this.selected[this.testSubjectsData[i].courseId] = [];
      this.disableTests[this.testSubjectsData[i].courseId] = [];
      this.subjectCorrect[this.testSubjectsData[i].courseId] = 0;
      this.subjectIncorrect[this.testSubjectsData[i].courseId] = 0;
      this.totalSubjects[
        this.testSubjectsData[i].courseId
      ] = this.testSubjectsData[i].mcqs.length;
    }
    this.startTime = moment();
    this.changeSubject(0);
  }

  private downloadVocab(item, index) {
    window.open('/documents/' + item.download);
  }

  private async showDetails(item, index) {
    window.scrollTo(0, 0);
    this.selectedWorkItem = item;
    this.currentWorkItem = index;
    this.testSubjectsData = [];
    this.currentSubjectTest = 0;
    this.sheetId = item.Title;

    if (item.Type == "Test") {
      let selectedWork = await this.service
        .getTest(item.Title, this.$store.state.selectSubject)
        .then((response) => {
          this.testSubjectsData = response;
          this.totalQuestions = 0;
          let mcqIndex = 1;
          for (let i = 0; i < this.testSubjectsData.length; i++) {
            this.testSubjectsData[i].mcqs = JSON.parse(
              this.testSubjectsData[i].mcqs
            );

            for (let j = 0; j < this.testSubjectsData[i].mcqs.length; j++) {
              this.testSubjectsData[i].mcqs[j].indx = mcqIndex;
              mcqIndex++;
            }
            this.totalSubjects[
              this.testSubjectsData[i].courseId
            ] = this.testSubjectsData[i].mcqs.length;
            this.totalQuestions += this.testSubjectsData[i].mcqs.length;
            this.selected[this.testSubjectsData[i].courseId] = [];
            this.disableTests[this.testSubjectsData[i].courseId] = [];
            this.subjectCorrect[this.testSubjectsData[i].courseId] = 0;
            this.subjectIncorrect[this.testSubjectsData[i].courseId] = 0;
          }
          this.selectedWorkItem = response[this.currentSubjectTest];
          this.view = 1;
          this.startTime = moment();
        });
    }
    this.view = 1;
    if (this.selectedWorkItem.VideoLink) {

      if (this.selectedWorkItem.VideoLink.indexOf('<iframe') != -1) {
        this.iframeHtml = this.selectedWorkItem.VideoLink;
        this.sourceLoaded = true;
      }
      else {
        this.iframeHtml = '';

        this.source = this.selectedWorkItem.VideoLink;
        setTimeout(() => {
          this.loadVideo();
        }, 1000);
      }
    }

    if (this.selectedWorkItem.mcqs) {
      for (let i = 0; i < this.selectedWorkItem.mcqs.length; i++) {
        this.correct[i] = this.selectedWorkItem.mcqs[i].answers[0];
      }
    }
  }

  setCorrect() {
    this.correct = [];

    for (let i = 0; i < this.selectedWorkItem.mcqs.length; i++) {
      this.correct[i] = this.selectedWorkItem.mcqs[i].answers[0];
    }
  }

  private nextWork() {
    if (this.currentWorkItem < this.tableItemsSorted.length - 1) {
      this.currentWorkItem++;
      this.showDetails(
        this.tableItemsSorted[this.currentWorkItem],
        this.currentWorkItem
      );
    }
  }

  private renderHTML(x) {
    return config.renderHTML(x);
  }

  private previousWork() {
    if (this.currentWorkItem !== 0) {
      this.currentWorkItem--;
      this.showDetails(
        this.tableItemsSorted[this.currentWorkItem],
        this.currentWorkItem
      );
    }
  }

  private openHelp() {
    this.$bvModal.show("how-to");
  }

  private joinTeam() {
    window.open(
      "https://elhelpfiles.azureedge.net/pgcelfiles/STEP/Resources/NEW-PMC-PUBLIC-SOS.pdf?sp=r&st=2020-10-22T07:44:05Z&se=2023-10-23T07:44:00Z&sv=2019-12-12&sig=pX6Y1iGlroRDpvGOjJDfYjEmZ7O0gMRYW7kqkqU7%2Fd4%3D&sr=f",
      "_blank"
    );
  }

  private goBack() {
    this.sourceLoaded = false;
    this.errorDisable = true;
    window.location.reload();
  }

  private rowClass(item, type) {
    if (!item || type !== "row") return;

    return "cursor-pointer";
  }

  private fields = [
    { key: "OrderNo", label: "Sr.", sortable: true },
    { key: "Type" },
    { key: "Title" },
  ];

  private sheetfields = [
    { key: "Type" },
    { key: "Title", sortable: true },
  ];

  private vocabFields = [
    { key: "sr", label: "Sr." },
    { key: "title" }
  ];

  private testfields = [{ key: "Type" }, { key: "Title", sortable: true }];

  checkAnswer(answer, i, item) {
    this.display[i] = true;
    if (this.correct[i].correctAnswer === answer) {
      Vue.set(this.answerAns, i, "alert-success");
      if (item) {
        this.subjectCorrect[item]++;
      }

      this.totalCorrect++;
    } else {
      if (item) {
        this.subjectIncorrect[item]++;
      }

      this.totalIncorrect++;
      Vue.set(this.answerAns, i, "alert-danger");
    }

    if (!this.disable[i]) this.attempted++;

    Vue.set(this.disable, i, true);

    if (item !== false) {
      this.disableTests[item][i] = true;
    }
  }

  private worksheetKey = 0;

  private resetMcqs() {
    this.attempted = 0;
    this.display = [];
    this.disable = [];
    this.answerAns = [];
    this.selected[this.selectedWorkItem.courseId] = [];
    this.worksheetKey++;
  }

  sortArray(array) {
    return array.sort(function (a, b) {
      let nameA = a.CourseId.toLowerCase(),
        nameB = b.CourseId.toLowerCase();
      if (nameA < nameB)
        //sort string ascending
        return -1;
      if (nameA > nameB) return 1;
      return 0; //default return value (no sorting)
    });
  }

  private loadVideo() {
    let client = document.getElementById("main-content");
    if (client !== null) {
      this.player = amp("azuremediaplayer", {
        nativeControlsForTouch: false,
        logo: { enabled: false },
        autoplay: true,
        controls: true,
        width: "auto",
        height: 600,
        techOrder: [
          "azureHtml5JS",
          "flashSS",
          "html5FairPlayHLS",
          "silverlightSS",
          "html5",
        ],
      });
    } else {
    }

    this.sourceLoaded = true;
  }

  private seperate(data, type) {
    if (type == "video") {
      this.lectures = [];
      this.discussions = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].Type == "Lecture") {
          this.lectures.push(data[i]);
        } else {
          this.discussions.push(data[i]);
        }
      }
    } else if (type == "test") {
      this.tests = [];
      this.worksheets = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].Type == "WorkSheet") {
          this.worksheets.push(data[i]);
        } else {
          this.tests.push(data[i]);
        }
      }
    }
  }

  mounted() {
    this.level_id = JSON.parse(localStorage[config.programSelect] || null);
    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }

    if (
      this.$store.state.selectSubject == "" ||
      this.$store.state.selectSubject == undefined ||
      this.$store.state.selectSubject == "null"
    ) {
      router.push("test-select");
    }

    let programInfo = JSON.parse(localStorage[config.programSelect]);

    if (programInfo.name.toLowerCase().indexOf('medical') > -1)
      this.isM = true;

    this.service
      .getWorkStepX(this.$store.state.selectSubject)
      .then((response) => {
        if (response[0].fullName && response[0].fullName === 'English')
          this.showVocab = true;
        if (response[0].video)
          this.seperate(JSON.parse(response[0].video), "video");
        if (response[0].workSheet)
          this.worksheets = JSON.parse(response[0].workSheet);
        if (response[0].test) this.tests = JSON.parse(response[0].test);

        for (let i = 0; i < this.tests.length; i++) {
          if (this.tests[i].Score !== null) {
            this.testAttempted = true;
          }
        }
      });

    window.onpopstate = function () {
      window.location.reload();
    };
  }
}
